import { useIllustrationThemeName } from "@octopusdeploy/design-system-components";
import { colorScales } from "@octopusdeploy/design-system-tokens";

export function useBlobFillColor() {
    const currentTheme = useIllustrationThemeName();
    return currentTheme === "light" ? colorScales.blue["100"] : colorScales.navy["700"];
}
